export const PARAMS_ENTITY = {
    tipo: {
        prefix: "",
        name: ":tipo",
        suffix: "s"
    },
    subtipo: {
        prefix: "",
        name: ":subtipo",
        suffix: ""
    },
    provincia: {
        prefix: "en-",
        name: ":provincia",
        suffix: ""
    },
    municipio: {
        prefix: "cerca-de-",
        name: ":municipio",
        suffix: ""
    },
    permalink: {
        prefix: "",
        name: ":permalink",
        suffix: ""
    },
    pagina: {
        prefix: "pag-",
        name: ":pagina",
        suffix: ""
    },
}

export const routes = {
    // buscador:   `${PARAMS_ENTITY.tipo.name}?${PARAMS_ENTITY.tipo.suffix}/${PARAMS_ENTITY.subtipo.name}?/${PARAMS_ENTITY.provincia.name}?/${PARAMS_ENTITY.municipio.name}?/${PARAMS_ENTITY.pagina.name}?`,
    buscador: `${PARAMS_ENTITY.tipo.name}${PARAMS_ENTITY.tipo.suffix}/${PARAMS_ENTITY.subtipo.name}?/${PARAMS_ENTITY.provincia.name}?/${PARAMS_ENTITY.municipio.name}?/${PARAMS_ENTITY.pagina.name}?`,

    buscadorProvincia: `${PARAMS_ENTITY.provincia.name}/`,
    buscadorProvinciaMun: `${PARAMS_ENTITY.provincia.name}/${PARAMS_ENTITY.municipio.name}/${PARAMS_ENTITY.pagina.name}?`,
    buscadorPagina: `${PARAMS_ENTITY.pagina.name}`,
    entityPermalink: `${PARAMS_ENTITY.tipo.name}/${PARAMS_ENTITY.permalink.name}`
}

export const routesPrefix = {
    rootBuscador: '/buscar-pet-friendly',
    rootEntity:"/pet-friendly"
}